import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';

import "./styles.scss";

export const Dropdown = props => {

  const { list, handleClick } = props;



  return (
    <div className="c-dropdown">
      <div className="c-dropdown__content">
        <Scrollbars
          renderTrackVertical={props => <div {...props} className="c-custom-scroll__track-vertical" />}
          renderThumbVertical={props => <div {...props} className="c-custom-scroll__thumb-vertical" />}
        >
          {
            list.map((item, i) => {
              return  <div
                key={i}
                className='c-dropdown__item'
                onClick={(e) => handleClick(e, item)}>
                <div className="c-dropdown__text">{item}</div>
              </div>
            })
          }
        </Scrollbars>
      </div>
    </div>
  )
};
